/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelEdiNotify.ts                     *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/edi-notify";

export class AutogenModelEdiNotify<RowType extends ModelRow> extends Endpoint<RowType, RowEdiNotifyFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowEdiNotify extends ModelRow<RowEdiNotifyFields> {
	constructor(values?: Partial<RowEdiNotifyFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowEdiNotifyFields {
	alt_partner_id: string;
	audit_cutoff_days: number;
	company_id: string;
	contact_id: string;
	direction: string;
	edi_dispatch_user: string;
	edi_operations_usr: string;
	id: string;
	method: string;
	notify_type: string;
	partner_id: string;
	print_device_id: string;
	profile_id: string;
	threshold: number;
	transaction_type: string;
	version: string;
}

